import React from 'react';
import { graphql } from 'gatsby';
import * as styles from './bento-block.module.scss';
import { BentoBlockFieldsFragment } from '../../../../generated/graphql';
import KeyFigureRowV2 from '../key-figure-row-v2/key-figure-row-v2';
import FramedText from '../framed-text/framed-text';
import { elementOffset } from '../../../functions/functions';
import { transformItem } from '../../../functions/functions';

type BentoBlockProps = {
    data: BentoBlockFieldsFragment
}

const BentoBlock: React.FC<BentoBlockProps> = ({ data }) => {
    return (
        <section className={styles.container}>
            {data.contentRow.map((row) => (
                <div className={styles.row}>
                    {row.__typename === 'DatoCmsArticleKeyFigureRowV2' && <KeyFigureRowV2 key={row.id} data={row} />}
                    {row.__typename === 'DatoCmsFramedText' && <FramedText key={row.id} data={row} />}
                </div>
            ))}
        </section>
    )
}

export default BentoBlock;

export const fragment = graphql`
    fragment BentoBlockFields on DatoCmsBentoBlock {
        id
        __typename
        contentRow {
            ...ArticleKeyFigureRowV2Fields
            ...FramedTextFields
        }
    }
`
